var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('img',{attrs:{"src":require("../assets/empty.png"),"alt":""}}),_c('p',[_vm._v("此链接已失效，请联系班主任")])])}]

export { render, staticRenderFns }